import { createSlice } from "@reduxjs/toolkit";
import {
  acceptUserRequest,
  deleteUser,
  getUserRequest,
  undoDeleteUser,
} from "./user.api";

const userRequestSlice = createSlice({
  name: "userRequest",
  initialState: {
    usersRequest: [],
    loading: false,
    error: null,
    success: null,
    dataLimit: 0,
    currentPage: 0,
    totalPages: 0,
    totalData: 0,
  },
  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUserRequest.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getUserRequest.fulfilled, (state, action) => {
      state.loading = false;
      state.usersRequest = action.payload;
      state.dataLimit = action.payload.meta.limit;
      state.currentPage = action.payload.meta.page;
      state.totalPages = action.payload.meta.totalPages;
      state.totalData = action.payload.meta.total;
    });
    builder.addCase(getUserRequest.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(acceptUserRequest.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(acceptUserRequest.fulfilled, (state, action) => {
      state.loading = false;
      state.usersRequest.data = state.usersRequest.data.filter(
        (user) => user._id !== action.payload.data._id
      );
      state.totalData = state.totalData - 1;
    });
    builder.addCase(acceptUserRequest.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(deleteUser.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteUser.fulfilled, (state, action) => {
      const deletedId = action.payload.id; // Use the deleted user ID from the payload

      if (state.users.data) {
        state.users.data = state.users.data.filter(
          (user) => user._id !== deletedId
        );
      }
      if (state.members.data) {
        state.members.data = state.members.data.data.filter(
          (member) => member._id !== deletedId
        );
      }
      state.loading = false;
    });
    builder.addCase(deleteUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(undoDeleteUser.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(undoDeleteUser.fulfilled, (state, action) => {
      const undodeletedId = action.payload.data._id;

      if (Array.isArray(state.users.data)) {
        state.users.data = state.users.data.filter(
          (user) => user._id !== undodeletedId
        );
      } else {
        console.error("state.users.data is not an array:", state.users.data);
      }
      state.loading = false;
    });
    builder.addCase(undoDeleteUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { resetState } = userRequestSlice.actions;
export default userRequestSlice.reducer;
